import { PerfilComponent } from './../perfil/perfil.component';
import { Form } from './../../models/form.model';
import { UserService } from 'src/app/services/user.service';
import { MatDialog, MatSnackBar } from 'node_modules/@angular/material';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { trigger, transition, style, animate, query, stagger, animateChild } from "@angular/animations";
import { FormService } from 'src/app/services/form.service';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { OptionService } from 'src/app/services/options.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import { AuxUrlComponent } from '../auxUrl/auxUrl.component';
import { AuxUrlcertComponent } from '../auxUrlcert/auxUrlcert.component';
import { AuxUrlInspeccionComponent } from '../aux-url-inspeccion/aux-url-inspeccion.component';
import { GLOBAL } from 'src/app/services/global';
import { AuxUrlInfTerComponent } from '../aux-url-inf-ter/aux-url-inf-ter.component';
import { AuxTotemComponent } from '../auxTotem/auxTotem.component';
import { MesonOnlineComponent } from '../meson-online/meson-online.component';
import { HomeComponent } from '../home/home.component';
import { ClaveUnicaComponent } from '../home/claveunica/claveunica.component';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';
import { ToastrService } from 'ngx-toastr';

interface AppState {
  form: Form;
}
declare const swal: any;

@Component({
  selector: 'page-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss'],
  providers: [FormService, OptionService, UserService, ClaveUnicaService],
  animations: [
    trigger('items', [
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }),  // initial
        animate('1.2s cubic-bezier(.8, -0.6, 0.26, 1.6)',
          style({ transform: 'scale(1)', opacity: 1 }))  // final
      ]),
      transition(':leave', [
        style({ transform: 'scale(1)', opacity: 1, height: '*' }),
        animate('0.6s cubic-bezier(.8, -0.6, 0.2, 1.5)',
          style({
            transform: 'scale(0.5)', opacity: 0,
            height: '0px', margin: '0px'
          }))
      ])
    ]),
    trigger('list', [
      transition(':enter', [
        query('@items', stagger(150, animateChild()))
      ]),
    ])
  ]
})


export class InicioComponent {

  @ViewChild('sub_tramitesCert') sub_tramitesCert: TemplateRef<any>;
  @ViewChild('sub_tramitesExp') sub_tramitesExp: TemplateRef<any>;
  @ViewChild('sub_tramitesIns') sub_tramitesIns: TemplateRef<any>;
  @ViewChild('sub_tramitesTot') sub_tramitesTot: TemplateRef<any>;

  public form;
  matcher = new FormService();
  servicios = []; //listado de los servicios y sus tramites internos
  ifNotServicios = false; //flag, para saber si no hay ningun servicio activo y que muestre un mensaje al usuario
  inputBuscar;
  identity;
  token;
  tokenCU;
  public footer = GLOBAL.footer;
  public web = GLOBAL.web;
  public webUrl = GLOBAL.webUrl;
  public nombreMuni = GLOBAL.nombreMuni;
  public contActivos = 0;

  constructor(
    private _optionService: OptionService,
    private dialog: MatDialog,
    private _userService: UserService,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private _router: Router,
    private claveUnicaService: ClaveUnicaService,
    private toastr: ToastrService
  ) {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    localStorage.clear();
    sessionStorage.removeItem('borrador');
    this.form = new FormGroup({
      buscar: new FormControl('', Validators.required)
    })
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    if (this.route.snapshot.paramMap.get("token")) {
      this._userService.activeUser(this.route.snapshot.paramMap.get("token")).subscribe(
        response => {
          console.log('cuenta activada, response', response)
          if (response.active) {
            alert("Cuenta activada");
          }
        },
        error => {
          let e = JSON.parse(error._body);
        }
      )
    }

    this.spinner.show();
    this._optionService.getServices().subscribe(
      response => {
        this.servicios = response;
        if (this.servicios.length < 0) {
          this.ifNotServicios = true
        }

        let flag = true
        for (let i = 0; i < this.servicios.length; i++) {
          if (this.servicios[i].active) flag = false
        }
        this.ifNotServicios = flag
      },
      error => {
        this.ifNotServicios = true
        console.log(error);
        console.log("Verifique la conexión a internet.")
      }
    )
    this.spinner.show()
    this.route.queryParams.subscribe(params => {
      this.tokenCU = params['tokenCU'] || null;

      if (this.tokenCU) {
        sessionStorage.setItem('authToken', this.tokenCU);

        this.claveUnicaService.obtenerSesion(this.tokenCU).subscribe(
          (response) => {
            let sesion = response;
            console.log("✅ Sesión encontrada");

            this.claveUnicaService.getInfoCiudadano(sesion.datos.code, sesion.datos.state).subscribe(response => {
              if (response) {
                swal({
                  type: 'success',
                  text: "Sesión iniciada con éxito",
                  showConfirmButton: true,
                  confirmButtonText: 'Aceptar',
                  allowOutsideClick: false
                })

                let identityjson = {
                  "active": true,
                  "apellidoM": response.name.apellidos[1] ? response.name.apellidos[1] : "",
                  "apellidoP": response.name.apellidos[0] ? response.name.apellidos[0] : "",
                  "dv": response.RolUnico.DV ? response.RolUnico.DV : "",
                  "email": '-',
                  "nombres": response.name.nombres[0] && response.name.nombres[1] ? response.name.nombres[0] + " " + response.name.nombres[1] : "",
                  "rut": response.RolUnico.numero ? response.RolUnico.numero : "",
                  "telefono": '-'
                }


                sessionStorage.setItem('identity-domCloud', JSON.stringify(identityjson));
                sessionStorage.setItem('token-domCloud', sesion.datos.code);


                let route = sesion.datos.route
                this._router.navigate([route]);
                this.spinner.hide()


              } else {
                this.spinner.hide()

              }
            });
          },
          (error) => {
            this.spinner.hide()
            console.error('Error al encontrar la sesion:', error);
            this.snackBar.open("❌ Error al encontrar la sesion.", "Cerrar", {
              duration: 3000,
            });
          }
        );
      } else if (!sessionStorage.getItem('identity-domCloud')) {
        this.spinner.hide()
        console.warn("❌ No se encontró la sesion.");
       /*  this.snackBar.open("❌ No se encontró la sesion.", "Cerrar", {
          duration: 3000,
        }); */
      }

      this.spinner.hide()
    });

  }

  ngOnInit() {

  }

  copyToClipboard(element) {

    var aux = document.createElement("input");
    aux.setAttribute("value", element);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
    this.toastr.success('Listo!', 'Email copiado al portapapeles');

  }

  sign(active?, url?) {
    console.log(active, url)

    if (active) {
      switch (url) {
        case 'expedientes':
          this.dialog.open(this.sub_tramitesExp)
          break;
        case 'certificados':
          this.dialog.open(this.sub_tramitesCert)
          break;
        case 'inspeccion':
          this.dialog.open(this.sub_tramitesIns)
          break;
        case 'informacion':
          this.dialog.open(AuxUrlInfTerComponent, {
            data: {
              url: url
            }
          })
          break;
        case 'atencion':
          this.dialog.open(MesonOnlineComponent, {
            data: {
              url: url
            }
          })
          break;
        case 'totem':
          this.dialog.open(this.sub_tramitesTot)
          break;
      }
    }
  }


  subTramite(select) {
    console.log(select);
    this.dialog.closeAll()
    sessionStorage.setItem('selected-route', select);

    if (select == "pago-derecho") {
      window.open('https://ww16.e-com.cl/Pagos/PagosVariosv3/?id=70', '_blank');
    } else if (select == "seguimiento-expediente" || select == "seguimiento_certificados" || select == "certificados" || select == "validar-certificado" || select == "validar-documento" || select == "totem-busqueda-direccion") {
      this._router.navigate([`/${select}`]);
    } else if (sessionStorage.getItem("identity-domCloud")) {
      this._router.navigate([`/${select}`]);
    } else {
      this.dialog.open(HomeComponent, {
        data: {
          url: select
        }
      })
    }
  }


  ngDoCheck() {

    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
  }

  handleImageError(card: any) {
    card.imageLoaded = false;
  }

  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");

    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
    this.back()
  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  back() {
    this._router.navigate(['/inicio'])
  }


  searchUser() {
    /* Buscar si existe en fm */
    let identityData = this._userService.getIdentity();
    let rut = identityData.rut + identityData.dv
    this._userService.buscarUsuario(rutClean(rut)).subscribe(
      response => {
        if (response.message) {
          this.spinner.hide();
          console.log(response);

        }
        if (response.register) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }

        if (response.update) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }

      },
      error => {
        let e = JSON.parse(error._body);
        this.spinner.hide();
      }
    )
  }

}